// 화면 오류 보고 — 라우터·경계가 부르는 얇은 입구(@sentry/react 는 main 이 꽂는다 · web Worker 가 router 를 import 해도 SDK 가 딸려 가지 않는다).

import { RpcError, RpcRedirect } from "@buildpy/api/client";
import { isNotFound, isRedirect } from "@tanstack/react-router";

type Reporter = (error: unknown) => void;

let reporter: Reporter | null = null;

export const setErrorReporter = (next: Reporter | null): void => {
  reporter = next;
};

// 이동·없음·4xx(로그인 필요·검증 거절)는 예상한 흐름 — 5xx·예상 못 한 오류만 보낸다.
export const shouldReport = (error: unknown): boolean => {
  if (error instanceof RpcRedirect || isNotFound(error) || isRedirect(error)) return false;
  return !(error instanceof RpcError && error.status < 500);
};

export const reportError = (error: unknown): void => {
  if (reporter && shouldReport(error)) reporter(error);
};
